"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Viewport = exports.SliderItemOuter = exports.SliderItem = exports.Slider = exports.CarouselWindow = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../../framework/ty"));

var _RatioBox = _interopRequireDefault(require("../../RatioBox/RatioBox.index"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

// update this to use better styling declaration
var CarouselWindow = (0, _styledComponents["default"])(_RatioBox["default"]).withConfig({
  displayName: "Carouselstyles__CarouselWindow",
  componentId: "sc-1gddjz1-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["", ""])), function (_ref) {
  var _theme$gallery;

  var theme = _ref.theme;
  return theme === null || theme === void 0 ? void 0 : (_theme$gallery = theme.gallery) === null || _theme$gallery === void 0 ? void 0 : _theme$gallery.carousel;
}));
exports.CarouselWindow = CarouselWindow;

var Viewport = _styledComponents["default"].div.withConfig({
  displayName: "Carouselstyles__Viewport",
  componentId: "sc-1gddjz1-1"
})(["", " margin-left:auto;margin-right:auto;"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["flex flex-column items-center h-100 w-100 mv0"]))));

exports.Viewport = Viewport;

var Slider = _styledComponents["default"].ul.withConfig({
  displayName: "Carouselstyles__Slider",
  componentId: "sc-1gddjz1-2"
})(["", " scroll-snap-type:x mandatory;list-style:none;-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"], (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["ma0 pa0 flex items-center h-100 w-100 overflow-x-auto overflow-y-hidden"]))));

exports.Slider = Slider;

var SliderItemOuter = _styledComponents["default"].li.withConfig({
  displayName: "Carouselstyles__SliderItemOuter",
  componentId: "sc-1gddjz1-3"
})(["scroll-snap-align:center;min-width:100%;"]);

exports.SliderItemOuter = SliderItemOuter;

var SliderItem = _styledComponents["default"].div.withConfig({
  displayName: "Carouselstyles__SliderItem",
  componentId: "sc-1gddjz1-4"
})(["", ""], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["w-100 h-100"]))));

exports.SliderItem = SliderItem;